import '.t{width:100%;}.ssr-plugin'
import '.er{border-radius:0.75rem;}.ssr-plugin'
import '.es{border:1px solid var(--shades-blue-300);}.ssr-plugin'
import '.et{padding:0.5rem 1rem;}.ssr-plugin'
import '.eu{font-size:1.125rem;}.ssr-plugin'
import '.e2{line-height:1.75rem;}.ssr-plugin'
import '.ev{resize:vertical;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef } from 'react'

export type MultiLineTextInputProps = {
  value: string
  placeholder?: string
  minHeight?: string
  style?: Style
  setValue: (value: string) => void
}

export const MultiLineTextInput = forwardRef<
  HTMLTextAreaElement,
  MultiLineTextInputProps
>(
  (
    {
      value,
      placeholder,
      minHeight = '6.5rem',
      style,
      setValue,
    }: MultiLineTextInputProps,
    ref,
  ) => {
    return (
      <styled.textarea className="t er es et eu e2 ev"
        ref={ref}
        style={{
          minHeight: minHeight,
          '&:focus': {
            outline: 'none',
            border: '1px solid var(--primary-blue)',
          },
          ...style,
        }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      ></styled.textarea>
    )
  },
)
